import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setNextPage } from '../../../redux/slices/appStateSlice';
import { resetSpouse, resetChildren } from '../../../redux/slices/quoteDataSlice';

const PartnerOrChildrenLogic = ({ fields, othersToAdd }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!othersToAdd.spouse) {
      dispatch(resetSpouse());
    }
    if (!othersToAdd.children) {
      dispatch(resetChildren());
    }
    if (othersToAdd.spouse) {
      dispatch(setNextPage(fields.spouseNextPage?.value?.href));
      return;
    }
    if (othersToAdd.children) {
      dispatch(setNextPage(fields.childNextPage?.value?.href));
      return;
    }
  }, [othersToAdd]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    othersToAdd: state.appState?.othersToAdd,
  };
};
export default connect(mapStateToProps)(PartnerOrChildrenLogic);
